'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var accounts = require('../accounts.cjs');
var gpaBuilders = require('../gpaBuilders.cjs');
var Operation = require('../../../types/Operation.cjs');
var Metadata = require('../models/Metadata.cjs');

// -----------------
// Operation
// -----------------

const Key = 'FindNftsByCreatorOperation';

/**
 * Finds multiple NFTs and SFTs by their creator at a given position.
 *
 * ```ts
 * // Find all by first creator.
 * const nfts = await metaplex
 *   .nfts()
 *   .findAllByCreator({ creator };
 *
 * // Find all by second creator.
 * const nfts = await metaplex
 *   .nfts()
 *   .findAllByCreator({ creator, position: 2 };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findNftsByCreatorOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findNftsByCreatorOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      programs
    } = scope;
    const {
      creator,
      position = 1
    } = operation.input;
    const gpaBuilder = new gpaBuilders.MetadataV1GpaBuilder(metaplex, metaplex.programs().getTokenMetadata(programs).address);
    const nfts = await gpaBuilder.whereCreator(position, creator).get();
    scope.throwIfCanceled();
    return nfts.map(account => {
      if (account == null) {
        return null;
      }
      try {
        return Metadata.toMetadata(accounts.toMetadataAccount(account));
      } catch (error) {
        return null;
      }
    }).filter(nft => nft !== null);
  }
};

exports.findNftsByCreatorOperation = findNftsByCreatorOperation;
exports.findNftsByCreatorOperationHandler = findNftsByCreatorOperationHandler;
//# sourceMappingURL=findNftsByCreator.cjs.map
